import React from "react";
import { Input as AntInput, Form } from "antd";
import styled from "styled-components";

const StyledFormItem = styled(Form.Item)`
  position: relative;
  margin-bottom: 24px;

  .ant-form-item-label {
    position: absolute;
    top: -10px;
    left: 10px;
    z-index: 2;
    margin: 0;
    padding: 0 4px;
    
    label {
      font-size: 14px;
      height: auto;
      color: rgba(0, 0, 0, 0.85);
      background: white;
      margin: 0;
      
      &::before {
        display: none;
      }

      &::after {
        display: none;
      }

      &.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
        &::after {
          display: inline-block;
          margin-left: 2px;
          color: #ff4d4f;
          font-size: 14px;
          font-family: SimSun, sans-serif;
          line-height: 1;
          content: '*';
        }
      }
    }
  }

  .ant-input {
    border-radius: 4px;
    padding: 8px 12px;
    border: 1px solid #d9d9d9;
    height: 60px;
    
    &:focus {
      border-color: #40a9ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  }

  .ant-input-affix-wrapper {
    padding: 0 12px;
    height: 60px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    
    &:focus,
    &-focused {
      border-color: #40a9ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
    
    .ant-input {
      height: 38px;
      padding: 0;
    }

    .ant-input-suffix {
      margin-left: 8px;
    }
  }
`;

const Input = ({ 
  label, 
  name, 
  required, 
  message,
  type = "text",
  rules: customRules = [],
  ...props 
}) => {
  const rules = [];
  
  if (required) {
    rules.push({ 
      required: true, 
      message: message || `Please input your ${label.toLowerCase()}!` 
    });
  }
  
  if (type === "email") {
    rules.push({ 
      type: 'email',
      message: 'Please enter a valid email address!'
    });
  }

  rules.push(...customRules);

  return (
    <StyledFormItem
      label={label}
      name={name}
      rules={rules}
      type={type}
    >
      {type === "password" ? (
        <AntInput.Password {...props} />
      ) : (
        <AntInput {...props} />
      )}
    </StyledFormItem>
  );
};

export default Input; 